jQuery(document).ready(function ($) {
  if($('.quote-slider').length){
    $('.quote-slider').slick({
      infinite: true,
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      prevArrow: $('.arrow-prev-custom'),
      nextArrow: $('.arrow-next-custom'),
    });
  }
});